export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const ADD_WHITELIST_WALLET = 'ADD_WHITELIST_WALLET';
export const DELETE_WHITELIST_WALLET = 'DELETE_WHITELIST_WALLET';
